import React from 'react';
import { Heart } from 'lucide-react';
import { Navigation } from './Navigation';
import { Footer } from './Footer';

export function ThankYouView({ onHomeClick, onScrollTo, onAdminClick }) {
    return (
        <div className="min-h-screen bg-[#fdfbf7] flex flex-col">
            <Navigation
                onScrollTo={onScrollTo}
                onAdminClick={onAdminClick}
                onHomeClick={onHomeClick}
            />
            <div className="flex-grow flex items-center justify-center px-6 py-20">
                <div className="max-w-2xl w-full bg-white p-10 md:p-16 rounded-3xl shadow-xl text-center border-t-8 border-[#d48c95]">
                    <div className="w-20 h-20 bg-[#fae1e5] rounded-full flex items-center justify-center mx-auto mb-8">
                        <Heart className="text-[#d48c95] w-10 h-10 fill-current" />
                    </div>
                    <h1 className="text-4xl md:text-5xl font-serif text-gray-800 mb-6">
                        Thank You for Choosing <br /><span className="text-[#c5a059]">FreeSpiritFabiha</span>
                    </h1>
                    <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                        You're officially on a path of self-love, alignment, and cultural freedom.
                        <br /><br />
                        <strong>Check your inbox for next steps</strong> — I'm so excited to support your journey.
                    </p>
                    <button
                        onClick={onHomeClick}
                        className="px-8 py-3 border-2 border-[#c5a059] text-[#c5a059] font-medium rounded-full hover:bg-[#c5a059] hover:text-white transition"
                    >
                        Back to Home
                    </button>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default ThankYouView;
